module.exports = __webpack_public_path__ + "img/curva.f753b89f.svg";